// src/api.js
import axios from 'axios';

const baseURL = process.env.VUE_APP_BASE_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

// Separate instance for chunked/multipart uploads — no timeout since parts may be large
export const uploadApi = axios.create({
  baseURL,
  withCredentials: true,
});

export default api;
